var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"test_app"}},[_c('h1',[_vm._v("老板你试试可以不")]),_c('button',{on:{"click":_vm.openExchange}},[_vm._v("打开交易所")])])}
var staticRenderFns = []

export { render, staticRenderFns }